var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info-title-Sml",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    id: "Oval-Copy",
    fill: "none",
    stroke: "#62A9A9",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.999996 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.35524e-15 0L5.00001 1.34526e-17L5.00001 3L-7.35524e-15 3L-7.35524e-15 0Z",
    transform: "matrix(1.192488E-08 1 -1 1.192488E-08 4.500005 6.000001)",
    id: "Rectangle-Copy",
    fill: "#62A9A9",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4.00001 3.10457 4.00001 2C4.00001 0.895431 3.10457 0 2 0C0.895432 0 0 0.895431 0 2C0 3.10457 0.895432 4 2 4Z",
    transform: "translate(1.000001 0)",
    id: "Oval",
    fill: "#62A9A9",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L6.00001 0L6.00001 0.999999L0 0.999999L0 0Z",
    transform: "translate(0 10.5)",
    id: "Rectangle",
    fill: "#62A9A9",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4 0L4 1L0 1L0 0Z",
    transform: "translate(0 6.000001)",
    id: "Rectangle-Copy-2",
    fill: "#62A9A9",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a3b429cf0ec494a1f58a038d0cfb5c12.svg";
export { ForwardRef as ReactComponent };